<script lang="ts">

    import type { Question } from "../../Model/Question";
    import { getContext, SvelteComponent } from "svelte";
    import type { Readable } from "svelte/store";
    import QuestionText from "./QuestionText.svelte";
    import QuestionDate from "./QuestionDate.svelte";
    import QuestionRadio from "./QuestionRadio.svelte";
    import type { GetAnswerFn } from "../../global";
    import FormSection from "./FormSection.svelte";
    import { Accordion, AccordionItem } from "sveltestrap";
    import QuestionCheck from "./QuestionCheck.svelte";
    import QuestionGrid from "./QuestionGrid.svelte";

    export let question: Question;

    const getAnswer: GetAnswerFn = getContext('getAnswer');
    const inputTypesMap: { [key: string]: typeof SvelteComponent } = {
        text        : QuestionText,
        date        : QuestionDate,
        bool        : QuestionRadio,
        multiple    : QuestionCheck,
        grid        : QuestionGrid,
    };

    let questionComponent: typeof SvelteComponent;
    let value: Readable<any>;
    let showSubsections = false;
    
    $: setupQuestion(question);
    $: toggleSubsections($value);

    function setupQuestion(question: Question): void {
        if (!(question.type in inputTypesMap)) {
            throw new Error(`Tipo de pregunta no soportado "${question.type}" en la pregunta "${question.id}".`);
        }
        value = getAnswer(question.id).valueReadable;
        questionComponent = inputTypesMap[question.type];
    }

    function toggleSubsections(value: any): void {
        
        if (!question.options.questionOptions) {
            showSubsections = false;
            return;
        }

        const questionSelect = question.options.questionOptions.find(q => q.id == value);

        if (!questionSelect?.unLock) {
            showSubsections = false;
            return;
        }

        showSubsections = !!question.options.questionOptions.find(({ id }) => id === value);
    }

</script>

<svelte:component this={questionComponent} {question} />

{#if showSubsections}
    <Accordion flush>
        {#each question.sections as section}
        <AccordionItem active>
            <h5 class="m-0" slot="header">{section.name}</h5>
            <FormSection {section} />
        </AccordionItem>
        {/each}
    </Accordion>
{/if}
